import React from 'react'

import { Link, useLocation } from 'react-router-dom'
import { FaArrowLeft, FaMinus } from 'react-icons/fa'
import Sidebar from '../../SideBar.js'
import styled from 'styled-components'
import axios from 'axios'
import { useEffect, useState } from 'react'

import Swal from 'sweetalert2'
import HeaderName from '../../HeaderName'
import apiInstance from '../../../../Utils/api.js'
// const label = styled.label``
// const input = styled.input`
//   width: 100%;
// `
function LabServiceRegister() {
  // const token = localStorage.getItem('token')
  // const url=process.env.REACT_APP_APP_URL
  // const api = axios.create({
  //   baseURL: url,
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //     'Content-Type': 'application/json'
  //   }
  // })

  const PackageID = useLocation().pathname.split('/')[2]
  // console.log(PackageID, 'p i')
  const [treatmentLists, setTreatmentLists] = useState([])
  const [unitArr, setUnitArr] = useState([])
  const [unitLists, setUnitLists] = useState([])
  const [showUnitLists, setShowUnitLists] = useState([])
  const [name, setName] = useState('')
  const [cost, setCost] = useState('')
  const [charges, setCharges] = useState('')
  const [status, setStatus] = useState('')
  const [packageLists, setPackageLists] = useState([])
  const [description, setDescription] = useState('')
  const [tempPackage, setTempPackage] = useState('')
  const [showUnit, setShowUnit] = useState(false)
  const [treatmentUnit, setTreatmentUnit] = useState('')
  const [upUnitLists, setUpUnitLists] = useState([])
  const [totalPrice, setTotalPrice] = useState('')
  const [totalCost, setTotalCost] = useState('')
  const [subTotalPrice, setSubTotalPrice] = useState('')
  const [subTotalCost, setSubTotalCost] = useState('')
  const [upTotalPrice, setUpTotalPrice] = useState('')
  const [upTotalCost, setUpTotalCost] = useState('')
  const [finalPrice, setFinalPrice] = useState('')
  const [finalSellPrice, setFinalSellPrice] = useState('')

  //Branch price update
  const [TCLtotalPrice, setTCLTotalPrice] = useState('')

  const [TCLsellPrice, setTCLSellPrice] = useState('')
  const [SCTotalPrice, setSCTotalPrice] = useState('')

  const [SCSellPrice, setSCSellPrice] = useState('')
  const [eightTotalPrice, setEightTotalPrice] = useState('')

  const [TggSellPrice, setTggSellPrice] = useState('')
  const [TggTotalPrice, setTggTotalPrice] = useState('')
  const [TGISellPrice, setTGISellPrice] = useState('')
  const [TGITotalPrice, setTGITotalPrice] = useState('')
  const [HTYTotalPrice, setHTYTotalPrice] = useState('')
  const [TMTotalPrice, setTMTotalPrice] = useState('')

  const [HTYSellPrice, setHTYSellPrice] = useState('')
  const [TMSellPrice, setTMSellPrice] = useState('')
  const [eightSellPrice, setEightSellPrice] = useState('')
  const [NptTotalPrice, setNptTotalPrice] = useState('')

  const [NptSellPrice, setNptSellPrice] = useState('')
  const [LSHTotalPrice, setLSHTotalPrice] = useState('')

  const [LSHSellPrice, setLSHSellPrice] = useState('')
  const [MDYTotalPrice, setMDYTotalPrice] = useState('')

  const [MDYSellPrice, setMDYSellPrice] = useState('')
  const [KTotalPrice, setKTotalPrice] = useState('')
  const [sellPrice, setSellPrice] = useState('')
  const [KSellPrice, setKSellPrice] = useState('')
  const [LMDtotalPrice, setLMDTotalPrice] = useState('')

  const [LMDsellPrice, setLMDSellPrice] = useState('')

  const [showPrice, setShowPrice] = useState(false)
  const [hello, setHello] = useState([])
  const [showHO, setShowHO] = useState(true)
  const [branchName, setBranchName] = useState('')
  const [branchList, setBranchList] = useState([])
  const [branch, setBranch] = useState('')
  const [showEight, setShowEight] = useState(false)
  const [showNPT, setShowNPT] = useState(false)
  const [showMDY, setShowMDY] = useState(false)
  const [showTGI, setShowTGI] = useState(false)
  const [showLSH, setShowLSH] = useState(false)
  const [showK, setShowK] = useState(false)
  const [showSC, setShowSC] = useState(false)
  const [showTgg, setShowTgg] = useState(false)
  const [showHTY, setShowHTY] = useState(false)
  const [showTM, setShowTM] = useState(false)
  const [showLMD, setShowLMD] = useState(false)
  const [showTCLTotal, setShowTCLTotal] = useState(false)
  const [finalTreatmentUnitLists, setFinalTreatmentUnitLists] = useState([])
  const [upAndAlreadyPrice, setUpAndAlreadyPrice] = useState('')
  const [upAndAlreadySell, setUpAndAlreadySell] = useState('')
  //Branch update end


  const handleDelete = (index) => {
    // console.log(index, 'ind')


    // console.log(upUnitLists.filter((el, ind) => ind !== index))
    const originPriceTotal = upUnitLists.reduce(
      (accumulator, item) => accumulator + item.price,
      0
    )
    const originSellTotal = upUnitLists.reduce(
      (accumulator, item) => accumulator + item.sellingPrice,
      0
    )

    // console.log(upUnitLists, 'list')
    const finalCalculatePrice = upAndAlreadyPrice ? (upAndAlreadyPrice - upUnitLists.filter((el, ind) => ind === index).reduce(
      (accumulator, item) => accumulator + item.price,
      0
    )) : (originPriceTotal - upUnitLists.filter((el, ind) => ind === index).reduce(
      (accumulator, item) => accumulator + item.price,
      0
    ))
    // console.log(finalCalculatePrice, 'finalCalculatePrice')
    const finalCalSellPrice = upAndAlreadySell ? (upAndAlreadySell - upUnitLists.filter((el, ind) => ind === index).reduce(
      (accumulator, item) => accumulator + item.sellingPrice,
      0
    )) : (originSellTotal - upUnitLists.filter((el, ind) => ind === index).reduce(
      (accumulator, item) => accumulator + item.sellingPrice,
      0
    ))
    setSellPrice(finalCalSellPrice)
    setTotalPrice(finalCalculatePrice)

    const subList = upUnitLists.filter((el, ind) => ind === index)
    const subPriceTotal = subList.reduce(
      (accumulator, item) => accumulator + item.price,
      0
    )
    const subSellTotal = subList.reduce(
      (accumulator, item) => accumulator + item.sellingPrice,
      0
    )
    // console.log(originSellTotal - subSellTotal, 'last list')
    setSubTotalPrice(originPriceTotal - subPriceTotal);
    setSubTotalCost(originSellTotal - subSellTotal);
    setFinalTreatmentUnitLists(upUnitLists.filter((el, ind) => ind !== index))
    setUpUnitLists(upUnitLists.filter((el, ind) => ind !== index))
    // console.log(upUnitLists.filter((el, ind) => ind !== index))
  };

  const handleBranch = id => {
    setBranch(id)
    if (id == '6474394fdab649311f9fcc32') {
      setBranchName('SOK')
    } else {
      setBranchName(branchList.filter(el => el._id === id)[0].name)
    }
    if (id == '6535f7fef68b0525e0eaf151') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(true)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }
    if (id == '6535f811f68b0525e0eaf152') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(true)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }

    if (id == '6474394fdab649311f9fcc32') {
      setShowEight(false)
      setShowHO(true)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }
    if (id == '64743985dab649311f9fcc33') {
      setShowEight(true)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }
    if (id == '64743991dab649311f9fcc34') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(true)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }
    if (id == '6474399edab649311f9fcc35') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(true)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }
    if (id == '647439aadab649311f9fcc36') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(true)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }
    if (id == '649559535fc22f0e7f0884fe') {
      if (TCLtotalPrice) {
        setShowTCLTotal(false)
      }
      setShowEight(false)
      setShowHO(false)
      setShowPrice(true)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }
    if (id == '64b6064a61cdd336e64f9300') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(true)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }

    if (id == '651647a617c8dbb264085bcf') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(true)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(false)
    }

    //HTY
    if (id == '66023ad88bb368fe815343da') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(true)
      setShowTM(false)
      setShowLMD(false)
    }

    //TM
    if (id == '66ed176674f503bf95858cf8') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(true)
      setShowLMD(false)
    }

    //LMD
    if (id == '675a5d8fb2a9c1d91266a144') {
      setShowEight(false)
      setShowHO(false)
      setShowPrice(false)
      setShowLSH(false)
      setShowNPT(false)
      setShowMDY(false)
      setShowK(false)
      setShowSC(false)
      setShowTgg(false)
      setShowTGI(false)
      setShowHTY(false)
      setShowTM(false)
      setShowLMD(true)
    }
  }
  var sumCost = 0
  var sumPrice = 0

  var sumUpCost = 0
  var sumUpPrice = 0

  const [price, setPrice] = useState('')
  const [Id, setId] = useState('')

  const handleAdd = Id => {
    setId(Id)
  }
  const handleBox = event => {
    let newPackage = {
      id: event,
      name: showUnitLists.filter(el => el._id == event)[0]
        ? showUnitLists.filter(el => el._id == event)[0].name
        : '',
      price: showUnitLists.filter(el => el._id == event)[0]
        ? showUnitLists.filter(el => el._id == event)[0].estimateTotalPrice
        : '',
      sellingPrice: showUnitLists.filter(el => el._id == event)[0]
        ? showUnitLists.filter(el => el._id == event)[0].sellingPrice
        : ''
    }

    // setUnitArr([...unitArr, newPackage])
    setUpUnitLists([...upUnitLists, newPackage])
    // console.log([...upUnitLists, newPackage], 'fakwadskl')
    //By Reduce
    // let tempMap = [...unitArr, newPackage]
    // const filteredTotal = tempMap.reduce(
    //   (accumulator, item) => accumulator + item.price,
    //   0
    // )
    // setTotalPrice(filteredTotal)

    //By Simple
    let temArr = [...upUnitLists, newPackage]

    const sell = temArr.reduce(
      (accumulator, item) => accumulator + item.sellingPrice,
      0
    )
    const price = temArr.reduce(
      (accumulator, item) => accumulator + item.price,
      0
    )

    upUnitLists.map((i, index) => {
      sumUpPrice += i.price
      setTotalPrice(sumPrice)
      // console.log(sumUpCost, 'cost')
    })


    // console.log(sell, 'up sell')
    // console.log(price, 'up price')
    setTotalPrice(price)
    setSellPrice(sell)
  }

  const TestPackageUpdate = event => {
    event.preventDefault()


    const data = {
      // id: PackageID,
      name: name,
      status: status,
      description: description
    }

    if (branch == '66023ad88bb368fe815343da' || HTYTotalPrice) {
      data.HlaingTharYarEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !HTYTotalPrice && finalTreatmentUnitLists) && totalPrice) || (HTYTotalPrice && HTYTotalPrice)
      data.HlaingTharYarSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !HTYSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (HTYSellPrice && HTYSellPrice)

    }

    if (branch == '651647a617c8dbb264085bcf' || TGITotalPrice) {
      data.TGIEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !TGITotalPrice && finalTreatmentUnitLists) && totalPrice) || (TGITotalPrice && TGITotalPrice)
      data.TGISellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !TGISellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (TGISellPrice && TGISellPrice)

    }
    if (branch == '6535f7fef68b0525e0eaf151' || SCTotalPrice) {
      data.SanChaungEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !SCTotalPrice && finalTreatmentUnitLists) && totalPrice) || (SCTotalPrice && SCTotalPrice)
      data.SanChaungSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !SCSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (SCSellPrice && SCSellPrice)
    }
    if (branch == '6535f811f68b0525e0eaf152' || TggTotalPrice) {
      data.ThingangyunEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !TggTotalPrice && finalTreatmentUnitLists) && totalPrice) || (TggTotalPrice && TggTotalPrice)
      data.ThingangyunSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !TggSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (TggSellPrice && TggSellPrice)
    }

    if (branch == '6474394fdab649311f9fcc32' || totalPrice) {
      data.SOKEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || totalPrice
      data.SOKSellingPrice = (unitArr && upAndAlreadySell) || (totalCost || sellPrice)

    }
    if (branch == '64743985dab649311f9fcc33' || eightTotalPrice) {
      data.EightMileEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !eightTotalPrice && finalTreatmentUnitLists) && totalPrice) || (eightTotalPrice && eightTotalPrice)
      data.EightMileSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !eightSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (eightSellPrice && eightSellPrice)
    }

    if (branch == '64743991dab649311f9fcc34' || NptTotalPrice) {
      data.NPTEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !NptTotalPrice && finalTreatmentUnitLists) && totalPrice) || (NptTotalPrice && NptTotalPrice)
      data.NPTSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !NptSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (NptSellPrice && NptSellPrice)
    }
    if (branch == '6474399edab649311f9fcc35' || LSHTotalPrice) {
      data.LSHEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !LSHTotalPrice && finalTreatmentUnitLists) && totalPrice) || (LSHTotalPrice && LSHTotalPrice)
      data.LSHSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !LSHSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (LSHSellPrice && LSHSellPrice)
    }
    if (branch == '647439aadab649311f9fcc36' || MDYTotalPrice) {
      data.MDYEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !MDYTotalPrice && finalTreatmentUnitLists) && totalPrice) || (MDYTotalPrice && MDYTotalPrice)
      data.MDYSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !MDYSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (MDYSellPrice && MDYSellPrice)
    }

    if (branch == '649559535fc22f0e7f0884fe' || TCLtotalPrice) {
      data.TCLEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !TCLtotalPrice && finalTreatmentUnitLists) && totalPrice) || (TCLtotalPrice && TCLtotalPrice)
      data.TCLSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !TCLsellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (TCLsellPrice && TCLsellPrice)
    }
    if (branch == '64b6064a61cdd336e64f9300' || KTotalPrice) {
      data.KEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !KTotalPrice && finalTreatmentUnitLists) && totalPrice) || (KTotalPrice && KTotalPrice)
      data.KSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !KSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (KSellPrice && KSellPrice)
    }
    if (branch == '66ed176674f503bf95858cf8' || TMTotalPrice) {
      data.TamweEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !TMTotalPrice && finalTreatmentUnitLists) && totalPrice) || (TMTotalPrice && TMTotalPrice)
      data.TamweSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !TMSellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (TMSellPrice && TMSellPrice)

    }
    //LMD
    if (branch == '675a5d8fb2a9c1d91266a144' || LMDtotalPrice) {
      data.LMDEstimateTotalPrice = (unitArr && upAndAlreadyPrice) || ((!unitArr && !LMDtotalPrice && finalTreatmentUnitLists) && totalPrice) || (LMDtotalPrice && LMDtotalPrice)
      data.LMDSellingPrice = (unitArr && upAndAlreadySell) || ((!unitArr && !LMDsellPrice && finalTreatmentUnitLists) && (totalCost || sellPrice)) || (LMDsellPrice && LMDsellPrice)

    }

    data.relatedTreatment = upUnitLists.map(i => i.id)



    // alert(JSON.stringify(data))
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    apiInstance
      .put('treatment-package/' + PackageID, data, config)
      .then(function (response) {
        Swal.fire({
          title: 'Success',
          text: 'Successfully Updated!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000
        })
        window.location.reload()
      })
      .catch(function (err) {
        Swal.fire({
          title: 'Error',
          text: 'Something Wrong',
          icon: 'error',
          showConfirmButton: false,
          timer: 2000
        })
      })

    document.getElementById('name').value = ''
    document.getElementById('desc').value = ''
    document.getElementById('status').value = ''

  }

  const handleUnit = event => {
    setShowUnitLists(
      unitLists.filter(
        el => (el.treatmentName ? el.treatmentName._id : '') == event
      )
    )

    setShowUnit(true)

    // console.log(
    //   unitLists.filter(
    //     el => (el.treatmentName ? el.treatmentName._id : '') == event
    //   )
    // )
  }
  useEffect(() => {
    const getTreatment = async () => {
      try {
        const res = await apiInstance.get('treatment-lists')

        setTreatmentLists(res.data.list)
        console.log(res.data.list, 'treat list')
      } catch (err) { }
    }

    const getUnitLists = async () => {
      try {
        const res = await apiInstance.get('treatments')

        setUnitLists(res.data.list)
      } catch (err) { }
    }

    const getPackageLists = async () => {
      try {
        const res = await apiInstance.get('treatment-package/' + PackageID)

        setPackageLists(res.data.data)
        console.log(res.data.data, 'pack up list')

        setName(res.data.data.name)
        setTotalCost(res.data.data.totalCost)
        setTotalPrice(res.data.data.totalPrice)
        setStatus(res.data.data.status)
        setDescription(res.data.data.description)
        setStatus(res.data.data.status)

        setEightTotalPrice(res.data.data.EightMileEstimateTotalPrice)
        setTCLTotalPrice(res.data.data.TCLEstimateTotalPrice)

        setTCLSellPrice(
          res.data.data.TCLSellingPrice
            ? res.data.data.TCLSellingPrice
            : ''
        )
        setHTYTotalPrice(res.data.data.HlaingTharYarEstimateTotalPrice)

        setHTYSellPrice(
          res.data.data.HlaingTharYarSellingPrice
            ? res.data.data.HlaingTharYarSellingPrice
            : ''
        )
        setTMTotalPrice(res.data.data.TamweEstimateTotalPrice)

        setTMSellPrice(
          res.data.data.TamweSellingPrice
            ? res.data.data.TamweSellingPrice
            : ''
        )
        setLMDTotalPrice(res.data.data.LMDEstimateTotalPrice)

        setLMDSellPrice(
          res.data.data.LMDSellingPrice
            ? res.data.data.LMDSellingPrice
            : ''
        )
        setNptTotalPrice(res.data.data.NPTEstimateTotalPrice)
        setSCTotalPrice(res.data.data.SanChaungEstimateTotalPrice)
        setSCSellPrice(res.data.data.SanChaungSellingPrice)
        setTggTotalPrice(res.data.data.ThingangyunEstimateTotalPrice)
        setTggSellPrice(res.data.data.ThingangyunSellingPrice)
        setNptSellPrice(res.data.data.NPTSellingPrice)

        setEightSellPrice(res.data.data.EightMileSellingPrice)
        setMDYTotalPrice(res.data.data.MDYEstimateTotalPrice)

        setMDYSellPrice(res.data.data.MDYSellingPrice)
        setLSHTotalPrice(res.data.data.LSHEstimateTotalPrice)

        setLSHSellPrice(res.data.data.LSHSellingPrice)

        setKTotalPrice(res.data.data.KShoppingEstimateTotalPrice)

        setKSellPrice(res.data.data.KShoppingSellingPrice)

        setSellPrice(res.data.data.SOKSellingPrice)
        setTotalPrice(res.data.data.SOKEstimateTotalPrice)
        setTGISellPrice(res.data.data.TGISellingPrice)
        setTGITotalPrice(res.data.data.TGIEstimateTotalPrice)


        if (
          res.data.data.relatedTreatment !== null &&
          res.data.data.relatedTreatment.length > 0
        ) {
          const newData = res.data.data.relatedTreatment.map(
            (data, index) => {
              return {
                name: data.name ? data.name : '',
                id: data._id,
                price: data.estimateTotalPrice,
                sellingPrice: data.sellingPrice
              }
            }
          )
          setUpUnitLists(newData)
          setShowUnit(true)
        }
      } catch (err) { }
    }
    const getBranches = async () => {
      const res = await apiInstance.get('branches')
      setBranchList(res.data.list)
    }

    getBranches()
    getPackageLists()
    getUnitLists()
    getTreatment()
  }, [])
  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <Sidebar />
        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <Link to='/package'>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className='breadcrumb-item active mt-1'>
                      Package Update
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section className='content'>
            <div className='container-fluid'>
              {/* <!-- Small boxes (Stat box) --> */}
              <div class='card'>
                {/* <h3 className="text-center py-3">Test Package Register</h3> */}
                <div class='card-body p-b-0 py-5 px-5'>
                  {/* @if($com == null) */}

                  {/* @csrf */}
                  <div className='form-body'>
                    <div className='form-group'>
                      <label>Package Name</label>
                      <input
                        type='text'
                        id='name'
                        className='form-control'
                        defaultValue={name}
                        onChange={e => setName(e.target.value)}
                      />
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <label className='control-label'>
                          Add Treatments
                        </label>
                        <div className='row d-flex justify-content-between'>
                          <div className='col-md-5'>
                            <select
                              class='custom-select border-info'
                              name='account_type_id'
                              id='flag'
                              // placeHolder='Treatments'
                              onChange={e => {
                                handleUnit(e.target.value)
                              }}
                            >
                              <option hidden>Choose Treatments</option>
                              {treatmentLists.map(option => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          {showUnit && (
                            <div className='col-md-5'>
                              <select
                                class='custom-select border-info'
                                name='account_type_id'
                                id='flag'
                                onChange={e => {
                                  handleAdd(e.target.value)
                                }}
                              >
                                <option hidden>Choose Unit</option>
                                {showUnitLists.map(option => (
                                  <option value={option._id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          <div className='col-md-1'>
                            <button
                              type='button'
                              className='btn btn-primary'
                              onClick={() => handleBox(Id)}
                            >
                              <i class='fa fa-plus'></i>
                            </button>
                          </div>
                        </div>

                        <div>
                          {console.log(upUnitLists, 'in co')}
                          {
                            upUnitLists.map((regArr, ind) => (
                              <div className='row mt-3'>
                                <div className='col-md-3'>
                                  <label>Unit Name</label>
                                  <input
                                    type='text'
                                    defaultValue={regArr.name}
                                    className='form-control'
                                  />
                                </div>
                                <div className='col-md-3'>
                                  <label>Price</label>
                                  <input
                                    type='text'
                                    value={regArr.price ? regArr.price : 0}
                                    className='form-control'
                                  />
                                </div>
                                <div className='col-md-3'>
                                  <label>Selling Price</label>
                                  <input
                                    type='text'
                                    value={regArr.sellingPrice ? regArr.sellingPrice : 0}
                                    className='form-control'
                                  />
                                </div>

                                <div className='col-md-2'>
                                  <button
                                    onClick={() => handleDelete(ind)}
                                    className='btn btn-sm btn-danger rounded-circle opacity-75'
                                    style={{ marginTop: '2.5em' }}
                                  >
                                    <FaMinus />
                                  </button>
                                </div>
                              </div>
                            ))
                          }
                        </div>



                      </div>
                    </div>
                    {/* <div className='form-group mt-3'>
                        <label>Total Price</label>
                        <input
                          type='number'
                          id='charge'
                          className='form-control'
                          defaultValue={
                            upUnitLists ? totalPrice + upTotalPrice : totalPrice
                          }
                          onChange={e => setPrice(e.target.value)}
                        />
                      </div>

                      <div className='form-group'>
                        <label>Total Cost</label>
                        <input
                          type='number'
                          id='cost'
                          className='form-control'
                          defaultValue={
                            upUnitLists ? totalCost + upTotalCost : totalCost
                          }
                          onChange={e => setCost(e.target.value)}
                        />
                      </div> */}

                    <div className='form-group'>
                      <label>Status</label>
                      <select
                        class='custom-select border-info'
                        name='account_type_id'
                        id='status'
                        onChange={e => setStatus(e.target.value)}
                      >
                        <option hidden>{status}</option>
                        <option value='Active'>Active</option>
                        <option value='Expired'>Expired</option>

                      </select>
                    </div>
                    <div class='form-group'>
                      <label for='name'>Branch</label>
                      <select
                        class='custom-select border-info'
                        name='account_type_id'
                        onChange={e => handleBranch(e.target.value)}
                      >
                        <option hidden>Select Branch</option>

                        {branchList.map(option => (
                          <option value={option._id}>{option.name}</option>
                        ))}
                      </select>
                    </div>

                    {showHO && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>Original Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={totalPrice}
                            onChange={e => setTotalPrice(e.target.value)}
                          />
                        </div>
                        {/* <div className='col-2 form-group mt-3'>
                            <label>Percent(%)</label>
                            <input
                              type='number'
                              className='form-control'
                              defaultValue={percent}
                              onChange={e => handlePercent(e.target.value)}
                            />
                          </div> */}
                        <div className='col-4 form-group mt-3'>
                          <label>Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={sellPrice}
                            onChange={e => setSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {/* HTY */}
                    {showHTY && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>Hlaing Thar Yar Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={HTYTotalPrice}
                            onChange={e => setHTYTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>Hlaing Thar Yar Selling Price</label>
                          <div className='input-group'>
                            <input
                              type='number'
                              className='form-control'
                              defaultValue={HTYSellPrice}
                              onChange={e => setHTYSellPrice(e.target.value)}
                            />

                          </div>
                        </div>
                      </div>
                    )}

                    {/* Tamwe */}
                    {showTM && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>Tamwe Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={TMTotalPrice}
                            onChange={e => setHTYTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>Tamwe Selling Price</label>
                          <div className='input-group'>
                            <input
                              type='number'
                              className='form-control'
                              defaultValue={TMSellPrice}
                              onChange={e => setTMSellPrice(e.target.value)}
                            />

                          </div>
                        </div>
                      </div>
                    )}
                    {showPrice && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>TCL Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={TCLtotalPrice}
                            onChange={e => setTCLTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>TCL Selling Price</label>
                          <div className='input-group'>
                            <input
                              type='number'
                              className='form-control'
                              defaultValue={TCLsellPrice}
                              onChange={e => setTCLSellPrice(e.target.value)}
                            />
                            <div
                              className='input'
                              style={{ marginTop: '0.5em' }}
                            >
                              <span className='input-group-text'>THB</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {showEight && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>8Mile Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            value={eightTotalPrice}
                            onChange={e => setEightTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>8Mile Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={eightSellPrice}
                            onChange={e => setEightSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showSC && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>Sanchaung Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            value={SCTotalPrice}
                            onChange={e => setSCTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>Sanchaung Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={SCSellPrice}
                            onChange={e => setSCSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showTgg && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>Thingangyun Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            value={TggTotalPrice}
                            onChange={e => setTggTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>Thingangyun Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={TggSellPrice}
                            onChange={e => setTggSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}

                    {showNPT && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>NPT Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={NptTotalPrice}
                            onChange={e => setNptTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>NPT Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={NptSellPrice}
                            onChange={e => setNptSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showMDY && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>MDY Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={MDYTotalPrice}
                            onChange={e => setMDYTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>MDY Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={MDYSellPrice}
                            onChange={e => setMDYSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showLSH && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>LSH Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={LSHTotalPrice}
                            onChange={e => setLSHTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>LSH Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={LSHSellPrice}
                            onChange={e => setLSHSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showTGI && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>Taungyii Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={TGITotalPrice}
                            onChange={e => setTGITotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>Taungyii Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            value={TGISellPrice}
                            onChange={e => setTGISellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showK && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>K Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={KTotalPrice}
                            onChange={e => setKTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>K Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={KSellPrice}
                            onChange={e => setKSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showLMD && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <label>LMD Total Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={LMDtotalPrice}
                            onChange={e => setLMDTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <label>LMD Selling Price</label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={LMDsellPrice}
                            onChange={e => setLMDSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}

                    <div className='col-md-12'>
                      <label>Description</label>
                      <textarea
                        rows='8'
                        cols='40'
                        id='desc'
                        className='form-control'
                        defaultValue={description}
                        onChange={e => setDescription(e.target.value)}
                      ></textarea>
                    </div>

                    <div className='form-actions mt-3'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <div className='row'>
                            <div className=' col-md-9'>
                              <button
                                // type='submit'
                                onClick={TestPackageUpdate}
                                className='btn btn-primary'
                              >
                                Update
                              </button>
                              &nbsp;
                              <button
                                type='button'

                                className='btn btn-danger'
                                data-dismiss='modal'
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <!-- /.row (main row) --> */}
                </div>
                {/*<!-- /.container-fluid --> */}
              </div>
            </div>
          </section>
          {/* <!-- /.content --> */}
        </div>

        {/* <!-- /.content-wrapper --> */}
        <footer className='main-footer'>
          <strong>
            Copyright &copy; 2017-2020{' '}
            <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>

        {/* <!-- Control Sidebar --> */}
        <aside className='control-sidebar control-sidebar-dark'>
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  )
}
export default LabServiceRegister
